(function () {
    'use strict';

    var imApp = angular.module('imApp');

    imApp.component('consignment', {
        templateUrl: 'views/components/views/consignment/consignment.template.html?v=' + imApp.version,
        controllerAs: 'vm',
        controller: [
            '$stateParams',
            '$timeout',
            '$window',
            'consignmentService',
            'consignmentPlanningService',
            'deliveryPlanningService',
            'rememberService',
            'stateService',
            'utilityService',
            'cargonizerApiService',
            'modalService',
            'ieScreenBlockService',
            'printService',
            'fileService',
            'translateService',
            'ttGridFactory',
            'layoutService',
            function ($stateParams, $timeout, $window, consignmentService, consignmentPlanningService, deliveryPlanningService, rememberService, stateService, utilityService, cargonizerApiService, modalService, ieScreenBlockService, printService, fileService, translateService, ttGridFactory, layoutService) {
                // #region VARIABLES & DEFINITIONS

                var vm = this;
                let webPageName = stateService.getCurrentName();
                let timerStockLocationKeyno = null;
                let selectListDeliveryMethodsIndexed = {};

                let variableNames = {
                    bg_consignmentselection: '',
                    bg_consignment_packing_selection: '',
                };

                let progress = {
                    runProgress: 'START',
                    label: 'progressbar',
                    field: '',
                    max: 0,
                    min: 0,
                    step: 0,
                    finishclose: '1',
                    abortclose: false,
                };

                let translations = {
                    error: '',
                    ok: '',
                    consignment_api_create_show_title: 'Varsel',
                    consignment_api_create_show_ok_label: 'OK',
                    consignment_print_label_show_title: 'Varsel',
                    consignment_print_label_show_ok_label: 'OK',
                };

                vm.model = {
                    tabletSize: layoutService.getMediaQueries().tablet,
                    webPageName: webPageName,
                    gridConsignmentLineReady: false,
                    tmp_deliverymethod_no: 0,
                    validateStatus: 0,
                    isDirty: false,
                    bgConsignmentSelection: {
                        selected: 'p',
                        buttons: [
                            { id: 'p', label: 'consignment_products', color: 'primary', onClick: () => setConsignmentSelectionView('p') },
                            { id: 'h', label: 'consignment_head', color: 'primary', onClick: () => setConsignmentSelectionView('h') },
                            { id: 'packing', label: 'consignment_packing', color: 'primary', onClick: () => setConsignmentSelectionView('packing') },
                        ],
                    },
                    bgConsignmentOther: {
                        selected: 'OTHER',
                        buttons: [
                            { id: 'OTHER', label: 'bg_consignment_other', color: 'primary', onClick: () => (vm.model.bgConsignmentOther.selected = 'OTHER') },
                            { id: 'REQUISITIONS', label: 'bg_consignment_requisitions', color: 'primary', onClick: () => (vm.model.bgConsignmentOther.selected = 'REQUISITIONS') },
                            { id: 'ORDERLINES', label: 'bg_consignment_orderlines', color: 'primary', onClick: () => (vm.model.bgConsignmentOther.selected = 'ORDERLINES') },
                        ],
                    },
                    bgConsignmentAddressSelection: {
                        selected: 'a',
                        buttons: [
                            { id: 'a', label: 'consignment_address', color: 'primary', onClick: () => (vm.model.bgConsignmentAddressSelection.selected = 'a') },
                            { id: 'o', label: 'consignment_other', color: 'primary', onClick: () => (vm.model.bgConsignmentAddressSelection.selected = 'o') },
                        ],
                    },
                    bgConsignmentAddressInfoSelection: {
                        selected: 'i',
                        buttons: [
                            { id: 'i', label: 'consignment_address_info', color: 'primary', onClick: () => (vm.model.bgConsignmentAddressInfoSelection.selected = 'i') },
                            { id: 'c', label: 'consignment_contact_info', color: 'primary', onClick: () => (vm.model.bgConsignmentAddressInfoSelection.selected = 'c') },
                        ],
                    },
                    bgConsignmentPackingSelection: {
                        selected: 'packing_send',
                        buttons: [
                            { id: 'packing_send', label: 'consignment_packing_send', color: 'primary', onClick: () => setConsignmentPackingSelectionView('packing_send') },
                            { id: 'packing_merge', label: 'consignment_packing_merge', color: 'primary', onClick: () => setConsignmentPackingSelectionView('packing_merge') },
                            { id: 'packing_details', label: 'consignment_packing_details', color: 'primary', onClick: () => setConsignmentPackingSelectionView('packing_details') },
                        ],
                    },
                    bgConsignmentPickSelection: {
                        selected: 'LOCATIONPICK',
                        buttons: [
                            { id: 'LOCATIONPICK', label: 'consignment_locationpick', color: 'primary', onClick: () => setConsignmentPickSelectionView('LOCATIONPICK'), disabled: 'hidden' },
                            { id: 'AUTOPICKED', label: 'consignment_autopicked', color: 'primary', onClick: () => setConsignmentPickSelectionView('AUTOPICKED') },
                            { id: 'MANUALPICK', label: 'consignment_manualpick', color: 'primary', onClick: () => setConsignmentPickSelectionView('MANUALPICK') },
                        ],
                    },
                    bgAuto: {
                        selected: 'SELECT',
                        buttons: [
                            { id: 'SELECT', label: 'consignment_gb_auto_select', color: 'primary', onClick: () => (vm.model.bgAuto.selected = 'SELECT') },
                            { id: 'GOTO', label: 'consignment_gb_auto_goto', color: 'primary', onClick: () => (vm.model.bgAuto.selected = 'GOTO') },
                        ],
                    },
                    consignmentShipmentButtons: [
                        {
                            id: 'new',
                            icon: 'fa fa-solid fa-plus',
                            color: 'primary',
                            type: 'primary',
                            onClick: () => {
                                stateService.go('consignmentshipment', {
                                    consignmentshipment_keyno: '0',
                                    stockplace_id: vm.model.edit.stockplace_id_from,
                                });
                            },
                        },
                        {
                            id: 'list',
                            icon: 'fa fa-solid fa-bars',
                            color: 'primary',
                            type: 'primary',
                            onClick: () => stateService.go('consignmentshipments'),
                        },
                    ],
                    consignmentShipmentButtonsExpanded: [
                        {
                            id: 'erase',
                            icon: 'fa fa-solid fa-eraser',
                            color: 'danger',
                            type: 'danger',
                            onClick: () => (vm.model.edit.consignmentshipment_keyno = '0'),
                        },
                        {
                            id: 'new',
                            icon: 'fa fa-solid fa-plus',
                            color: 'primary',
                            type: 'primary',
                            onClick: () => {
                                stateService.go('consignmentshipment', {
                                    consignmentshipment_keyno: '0',
                                    stockplace_id: vm.model.edit.stockplace_id_from,
                                });
                            },
                        },
                        {
                            id: 'list',
                            icon: 'fa fa-solid fa-bars',
                            color: 'primary',
                            type: 'primary',
                            onClick: () => stateService.go('consignmentshipments'),
                        },
                        {
                            id: 'goto',
                            icon: 'fa fa-solid fa-chevron-right',
                            color: 'primary',
                            type: 'primary',
                            onClick: () => {
                                if (vm.model.edit.consignmentshipment_keyno > 0) {
                                    stateService.go('consignmentshipment', {
                                        consignmentshipment_keyno: vm.model.edit.consignmentshipment_keyno,
                                        stockplace_id: vm.model.edit.stockplace_id_from,
                                    });
                                }
                            },
                        },
                    ],
                    consignmentCarriersButtons: [{ id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('consignmentcarrierone', { consignment_keyno: vm.model.edit.consignment_keyno }) }],
                    orderOrderNosButtons: [{ id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('orderhead', { order_internal_no: vm.model.edit.order_internal_no_first }) }],
                    consigneeEmailButtons: [{ id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => (vm.model.edit.consignee_email = '') }, { id: '$email' }],
                    consigneeMobileButtons: [{ id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => (vm.model.edit.consignee_mobile = '') }, { id: '$phone' }],
                    consigneePhoneButtons: [{ id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => (vm.model.edit.consignee_phone = '') }, { id: '$phone' }],
                    cargonizerPrinters: {
                        records: [],
                    },
                    edit: {},
                    selectListDeliveryMethods: [],
                    p2ConsignmentConsignmentOlList: {},
                    p2ConsignmentConsignmentLineList: {},
                    itemsListCollis: [],
                    p2ConsignmentConsignmentLinePickList: {
                        records: [],
                    },
                    p2PortalUserVariableSetWs: {},
                    p2ConsignmentAssignSb: {},
                    p2ConsignmentRefreshWeightVolum: {},
                    p2ConsignmentSelectedToPick: {},
                    deliverConsignment: {},
                    selectListStockLocations: [],
                    listStockTransferLoadConsignmentPrePick: [],
                    selectListConsignmentShipments: [],
                    p2ConsignmentSave: {
                        saveok: '0',
                    },
                    locked: '0',
                    is_cargonizer: 0,
                    lockedPrePickFinished: false,
                    loadingPicked: false,
                    lockedRollback: false,
                };

                vm.cargonizerEnabled = 0;

                vm.gridConsignmentLine = new ttGridFactory({
                    rememberId: 'w_consignment_consignmentline_grid',
                    kendo: {
                        height: null,
                        sortable: true,
                        aggregate: true,
                        pager: false,
                        selectable: false,
                        filterable: false,
                    },
                }).setCustomToolbarButtons([
                    {
                        name: 'consigment_consignmentline_delete_assignments',
                        text: 'consigment_consignmentline_delete_assignments',
                        func: () => progressDeleteFunc(),
                        icon: 'fa-trash-alt',
                        cssClass: 'btn btn-danger im-grid-btn-xs-r',
                        translate: true,
                        disabled: () => {
                            return canDeleteRows() ? false : true;
                        },
                    },
                    {
                        name: 'consignment_assign',
                        text: 'consignment_assign',
                        func: () => {
                            consignmentService.assignItems({ consignment_keyno: vm.model.edit.consignment_keyno }).then(function (response) {
                                if (response[0].errorcode !== '0') {
                                    modalService.show({
                                        type: 'warning',
                                        title: translations.error,
                                        message: response[0].errormessage,
                                        buttons: [
                                            {
                                                label: translations.ok,
                                                cssClass: 'btn-warning',
                                                action: function (dialogItself) {
                                                    dialogItself.close();
                                                    loadGridConsignmentLine();
                                                },
                                            },
                                        ],
                                    });
                                } else {
                                    loadGridConsignmentLine();
                                }
                            });
                        },
                        icon: 'fa-sync-alt',
                        cssClass: 'btn btn-primary im-grid-btn-xs-r',
                        translate: true,
                    },
                ]);

                vm.gridColli = new ttGridFactory({ rememberId: 'w_consignment.colli.grid' }).setLoadDataFunction({ method: 3810, parameters: () => vm.model.edit });

                function canDeleteRows() {
                    const selectedRows = vm.gridConsignmentLine.gridfunc.getIsSelectedRows();
                    return selectedRows?.length && selectedRows.filter((e) => e.is_selected === '0' || e.is_selected === false).length === 0;
                }

                // #endregion VARIABLES & DEFINITIONS

                // #region TRANSLATE SERVICE

                async function translate() {
                    let data = await translateService.translateBatch(translations);

                    Object.keys(translations).forEach((key) => {
                        if (data?.[key]) translations[key] = data[key];
                    });
                }

                // #endregion TRANSLATE SERVICE

                // #region BUTTON RADIO FUNCTIONS

                function setConsignmentSelectionView(id) {
                    vm.model.bgConsignmentSelection.selected = vm.model.edit.bg_consignmentselection = id;
                }

                function setConsignmentPackingSelectionView(id) {
                    vm.model.bgConsignmentPackingSelection.selected = vm.model.edit.bg_consignment_packing_selection = id;
                }

                function setConsignmentPickSelectionView(id) {
                    vm.model.bgConsignmentPickSelection.selected = vm.model.edit.bg_ConsignmentPickSelection = id;
                }

                // #endregion BUTTON RADIO FUNCTIONS

                // ###################
                // LOAD PROCEDURE CALL
                // ###################

                async function loadEdit(skipNavigation) {
                    consignmentService
                        .getEdit({ consignment_keyno: $stateParams.consignment_keyno })
                        .then((info) => {
                            angular.copy(info[0], vm.model.edit);

                            vm.model.tmp_deliverymethod_no = vm.model.edit.deliverymethod_no;

                            if (!skipNavigation) {
                                setConsignmentSelectionView(vm.model.edit.bg_consignmentselection);

                                if (vm.model.edit.bg_consignmentselection === 'packing') {
                                    setConsignmentPackingSelectionView(vm.model.edit.bg_consignment_packing_selection);
                                } else if (vm.model.edit.bg_consignmentselection === 'p') {
                                    setConsignmentPickSelectionView(vm.model.edit.bg_ConsignmentPickSelection);
                                }
                            }

                            if (vm.model.edit.floating_location === '1') {
                                vm.model.bgConsignmentPickSelection.buttons[0].disabled = false;
                            } else {
                                vm.model.bgConsignmentPickSelection.buttons[0].disabled = true;
                            }

                            loadDeliveryMethods();
                            loadStockLocations();
                            loadStockTransferLoadConsignmentPrePick();
                        })
                        .then(() => loadConsignmentShipments());

                    consignmentService.loadP2ConsignmentConsignmentOlList($stateParams.consignment_keyno).then(function () {
                        vm.model.p2ConsignmentConsignmentOlList = consignmentService.p2ConsignmentConsignmentOlList;
                    });

                    consignmentService.loadP2ConsignmentConsignmentLineList($stateParams.consignment_keyno).then(function () {
                        vm.model.p2ConsignmentConsignmentLineList = consignmentService.p2ConsignmentConsignmentLineList;
                    });
                }

                vm.getP2ConsignmentSelectedToPick = function () {
                    vm.model.loadingPicked = true;

                    consignmentService.genericFunction(755, vm.model.p2ConsignmentConsignmentLineList).then(function (data) {
                        vm.model.p2ConsignmentSelectedToPick = angular.copy(data[0]);

                        if (vm.model.p2ConsignmentSelectedToPick.completed_ok === '1') {
                            vm.model.loadingPicked = false;
                            vm.consignmentAssign();
                        } else {
                            vm.model.loadingPicked = false;
                            vm.consignmentAssign();
                        }
                    });
                };

                async function loadStockLocations() {
                    console.log('her1');
                    if (utilityService.validateParmsValue(vm.model.edit.stockplace_id_from) !== true) return;
                    console.log('her2');
                    vm.model.selectListStockLocations = await consignmentService.listStockLocations({ stockplace_id: vm.model.edit.stockplace_id_from });
                    console.log('her3');
                    console.dir(vm.model.selectListStockLocations);
                }

                var loadStockTransferLoadConsignmentPrePick = function () {
                    if (angular.isDefined(vm.model.edit.stocktransfer_keyno) && vm.model.edit.stocktransfer_keyno > 0) {
                        consignmentService.loadStockTransferLoadConsignmentPrePickList(vm.model.edit.stocktransfer_keyno).then(function (data) {
                            angular.copy(data, vm.model.listStockTransferLoadConsignmentPrePick);
                        });
                    }
                };

                async function loadConsignmentShipments() {
                    if (utilityService.validateParmsValue(vm.model.edit.stockplace_id_from) !== true) return;

                    vm.model.selectListConsignmentShipments = await deliveryPlanningService.listConsignmentShipments({ stockplace_id: vm.model.edit.stockplace_id_from });
                }

                // #region GRID PROCEDURE FUNCTION CALLS

                async function loadGridConsignmentLine() {
                    vm.gridConsignmentLine.dataTask.loadData = {
                        method: 3556,
                        parameters: { consignment_keyno: $stateParams.consignment_keyno },
                    };

                    vm.model.gridConsignmentLineReady = true;

                    if (vm.gridConsignmentLine.gridfunc !== null) vm.gridConsignmentLine.gridfunc.read();
                }

                // #endregion GRID PROCEDURE FUNCTION CALLS

                // ######################
                // ASSIGN BUTTON FUNCTION
                // ######################

                vm.consignmentAssign = function (index) {
                    consignmentService.getP2ConsignmentAssignSb(vm.model.edit.consignment_keyno).then(function () {
                        vm.model.p2ConsignmentAssignSb = consignmentService.p2ConsignmentAssignSb;

                        if (vm.model.p2ConsignmentAssignSb.errorcode !== '0') {
                            modalService.show({
                                type: 'warning',
                                title: 'Varsel',
                                message: vm.model.p2ConsignmentAssignSb.errormessage,
                                buttons: [
                                    {
                                        label: 'OK',
                                        cssClass: 'btn-warning',
                                        action: function (dialogItself) {
                                            dialogItself.close();
                                            vm.model.loadingPicked = false;

                                            consignmentService.loadP2ConsignmentConsignmentLineList($stateParams.consignment_keyno).then(function () {
                                                vm.model.p2ConsignmentConsignmentLineList = consignmentService.p2ConsignmentConsignmentLineList;
                                            });
                                        },
                                    },
                                ],
                            });
                        } else {
                            vm.model.loadingPicked = false;

                            consignmentService.loadP2ConsignmentConsignmentLineList($stateParams.consignment_keyno).then(function () {
                                vm.model.p2ConsignmentConsignmentLineList = consignmentService.p2ConsignmentConsignmentLineList;
                            });
                        }
                    });
                };

                vm.loadP2ConsignmentConsignmentLinePickList = function () {
                    consignmentService.loadP2ConsignmentConsignmentLinePickList($stateParams.consignment_keyno).then(function (data) {
                        vm.model.p2ConsignmentConsignmentLinePickList = consignmentService.p2ConsignmentConsignmentLinePickList;
                    });
                };

                vm.loadP2ConsignmentConsignmentLinePickList();

                vm.onPrepickClick = function (item) {
                    consignmentService.getP2PortalUserVariableSetWs('consignment_prepick_special_product', item?.special_product ?? '').then(function () {
                        stateService.go('stocktransferloaditem', item.item_parms);
                    });
                }

                // #######################
                // COLLI DETAILS FUNCTION
                // #######################

                vm.goColliDetails = function () {
                    //console.log('Jepp');
                };

                vm.returnFirstValue = function () {};

                // #######################
                // LOAD CONSIGNMENT COLLI
                // #######################

                async function loadCollis() {
                    vm.gridColli?.gridfunc?.read();
                    if (utilityService.validateParmsValue(vm.model.edit.consignment_keyno) !== true) return;
                    if (utilityService.validateParmsValue(vm.model.edit.bg_consignment_packing_selection) !== true) return;

                    if (vm.model.edit.consignment_keyno > 0) {
                        const list = await consignmentService.listCollis({
                            consignment_keyno: vm.model.edit.consignment_keyno,
                            retreive_type: vm.model.edit.bg_consignment_packing_selection,
                        });

                        vm.model.itemsListCollis = list;

                        var wgt = 0;
                        var vol = 0;
                        var colli = 0;

                        vm.model.itemsListCollis.forEach((item) => {
                            if (parseFloat(item.item_weight)) {
                                wgt += parseFloat(item.item_weight);
                            }

                            if (parseFloat(item.item_volume)) {
                                vol += parseFloat(item.item_volume);
                            }

                            colli += 1;
                        });

                        vm.model.edit.weight = wgt;

                        if (vm.model.edit.show_xyz === '0') vm.model.edit.volum = vol;

                        vm.model.edit.colli = colli;
                    }
                }

                // #######################
                // MERGE CONSIGNMENT COLLI
                // #######################

                vm.mergeConsignmentCollies = function () {
                    var parms = {
                        consignment_keyno: $stateParams.consignment_keyno,
                        data: vm.model.itemsListCollis,
                    };

                    consignmentService.mergeConsignmentCollies(parms).then(function () {
                        loadCollis();
                    });
                };

                // #######################
                // SPLIT CONSIGNMENT COLLI
                // #######################

                vm.splitConsignmentCollies = function () {
                    var parms = {
                        consignment_keyno: $stateParams.consignment_keyno,
                        data: vm.model.itemsListCollis,
                    };

                    consignmentService.splitConsignmentCollies(parms).then(function () {
                        loadCollis();
                    });
                };

                // ###################
                // CHECK ALL FUNCTION
                // ###################

                vm.showChecked = false;

                vm.checkButtonClick = function () {
                    if (!vm.showChecked) {
                        vm.showChecked = true;
                        vm.selectAll();
                    } else {
                        vm.showChecked = false;
                        vm.unselectAll();
                    }
                };

                vm.selectAll = function () {
                    angular.forEach(vm.model.p2ConsignmentConsignmentLineList.records, function (item) {
                        item.item_is_selected = '1';
                        //item.item_glyphicon_color = 'green';
                    });
                };

                vm.unselectAll = function () {
                    angular.forEach(vm.model.p2ConsignmentConsignmentLineList.records, function (item) {
                        item.item_is_selected = '0';
                        //item.item_glyphicon_color = 'black';
                    });
                };

                // #####################################
                // CHECK DELIVERY METHOD BUTTON FUNCTION
                // #####################################

                vm.checkDeliveryMethod = function (index) {
                    $timeout(function () {
                        angular.forEach(vm.model.selectListDeliveryMethods, function (item) {
                            if (vm.model.edit.deliverymethod_no === item.deliverymethod_no) {
                                if (item.deliverymethod_cargonizer != '') {
                                    vm.cargonizerEnabled = 0;
                                    vm.cargonizerEnabled = 1;
                                }

                                vm.model.edit.send_delivery_confirmation = item.send_delivery_confirmation;

                                return 0;
                            }
                        });

                        if (vm.model.edit.deliverymethod_no === null) {
                            vm.model.edit.deliverymethod_no = vm.model.tmp_deliverymethod_no;
                        } //else {

                        vm.model.is_cargonizer = 0;

                        if (angular.isDefined(selectListDeliveryMethodsIndexed)) {
                            var chk = selectListDeliveryMethodsIndexed[vm.model.edit.deliverymethod_no];

                            if (chk) {
                                if (chk.deliverymethod_cargonizer !== '0' && chk.deliverymethod_cargonizer !== '') {
                                    vm.model.is_cargonizer = 1;
                                }
                            }
                        }
                    }, 100);
                };

                // ####################################
                // VALIDATE CONSIGNMENT BUTTON FUNCTION
                // ####################################

                vm.manualPick = function (item) {
                    consignmentService.getP2PortalUserVariableSetWs('active_consignmentline_keyno', item.item_id).then(function () {
                        vm.model.p2PortalUserVariableSetWs = consignmentService.p2PortalUserVariableSetWs;

                        stateService.go(item.item_state, item.item_parms);
                    });
                };

                // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

                function rememberFunc(id) {
                    Object.keys(variableNames).forEach((key) => {
                        switch (key) {
                            case 'bg_consignmentselection':
                                variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + 'consignmentselection';
                                break;
                            case 'bg_consignment_packing_selection':
                                variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + 'consignmentpackingselection';
                                break;
                            default:
                                variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                                break;
                        }
                    });

                    if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                    let variableValue = null;

                    switch (id) {
                        case 'bg_consignmentselection':
                        case 'bg_consignment_packing_selection':
                            if (utilityService.validateParmsValue(vm.model.edit[id]) !== true) return;

                            variableValue = vm.model.edit[id];
                            break;
                        default:
                            break;
                    }

                    return rememberService.remember(variableNames[id], variableValue);
                }

                //rememberFunc('bg_consignmentselection');

                // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

                // ############################
                // GET WAY BILL BUTTON FUNCTION
                // ############################

                vm.getWaybill = function (url) {
                    var tab = $window.open('_blank');
                    tab.location = url;
                    /*var aurl = 'http://www.vg.no';
                cargonizerApiService.getCargonizerWaybill($stateParams.consignment_keyno,aurl).then(function(){
    
                });*/
                };

                // #####################
                // PRINT BUTTON FUNCTION
                // #####################

                vm.printCargonizerReport = function (docarcFileName) {
                    cargonizerApiService.printCargonizerConsignmentReport($stateParams.consignment_keyno, vm.model.edit.cargonizer_printer_id, docarcFileName).then(function () {
                        vm.model.edit = consignmentService.p2ConsignmentGet;
                        loadDeliveryMethods();
                        vm.model.locked = '0';
                        ieScreenBlockService.stop();
                    });
                };

                // ##################################
                // CREATE CONSIGNMENT BUTTON FUNCTION
                // ##################################

                var loadPrintLabelApi = function () {
                    consignmentService
                        .printLabelCargonizerApi({
                            consignment_keyno: vm.model.edit.consignment_keyno,
                            cargonizer_printer_id: vm.model.edit.cargonizer_printer_id,
                        })
                        .then(function (response) {
                            if (response[0].errorcode !== '0') {
                                ieScreenBlockService.stop();

                                modalService.show({
                                    type: 'warning',
                                    title: translations.consignment_print_label_show_title,
                                    message: response[0].errormessage,
                                    buttons: [
                                        {
                                            label: translations.consignment_print_label_show_ok_label,
                                            cssClass: 'btn-warning',
                                            action: function (dialogItself) {
                                                dialogItself.close();
                                                vm.model.locked = '0';
                                            },
                                        },
                                    ],
                                });
                            } else {
                                ieScreenBlockService.stop();
                                vm.model.locked = '0';
                            }
                        });
                };

                vm.createConsignment = function () {
                    vm.model.locked = '1';

                    ieScreenBlockService.start('message');
                    ieScreenBlockService.setMessage('Validating consignment.');

                    consignmentService.saveConsignmentHead(vm.model.edit).then(function () {
                        cargonizerApiService.validateCargonizerConsignment($stateParams.consignment_keyno, vm.model.edit.deliverymethod_no, vm.model.edit.colli, vm.model.edit.weight, vm.model.edit.volum).then(function (data) {
                            vm.model.validateStatus = data[0].status;
                            vm.model.validateMessage = data[0].status_message;
                            //vm.model.validateStatus = cargonizerApiService.validateStatus.status;

                            if (vm.model.validateStatus === '0') {
                                ieScreenBlockService.setMessage('Validering OK (' + vm.model.edit.colli + '/' + vm.model.edit.weight + '/' + vm.model.edit.volum + ')');
                                vm.model.tmp_deliverymethod_no = vm.model.edit.deliverymethod_no;

                                /*$timeout(function () {
                                ieScreenBlockService.stop();
                                vm.model.locked = '0';
                            }, 1500);*/

                                if (vm.model.edit.tracking_url !== '') {
                                    ieScreenBlockService.setMessage('Printing labels....');
                                    //vm.printConsignment();
                                    loadPrintLabelApi();
                                } else {
                                    ieScreenBlockService.setMessage('Webshop Pre Validate');

                                    consignmentService.consignmentWebshopPreValidate({ consignment_keyno: $stateParams.consignment_keyno }).then(function (data) {
                                        if (data[0].status_no == '0') {
                                            consignmentService.createCargonizerConsignment($stateParams.consignment_keyno, vm.model.edit.deliverymethod_no, vm.model.edit.colli, vm.model.edit.weight, vm.model.edit.volum).then(function (response) {
                                                ieScreenBlockService.stop();

                                                if (response[0].errorcode !== '0') {
                                                    modalService.show({
                                                        type: 'warning',
                                                        title: translations.consignment_api_create_show_title,
                                                        message: response[0].errormessage,
                                                        buttons: [
                                                            {
                                                                label: translations.consignment_api_create_show_ok_label,
                                                                cssClass: 'btn-warning',
                                                                action: function (dialogItself) {
                                                                    dialogItself.close();
                                                                    vm.model.locked = '0';
                                                                },
                                                            },
                                                        ],
                                                    });
                                                } else {
                                                    if (response[0].consignment_keyno > 0) {
                                                        consignmentService.deliverConsignment(vm.model.edit).then(function (response) {});
                                                    }

                                                    consignmentService.getEdit({ consignment_keyno: $stateParams.consignment_keyno }).then((info) => {
                                                        ieScreenBlockService.setMessage('Updating external party');

                                                        consignmentService.completeConsignmentInWebshop({ consignment_keyno: $stateParams.consignment_keyno }).then(function () {
                                                            //if (vm.model.deliverymethod_own_label === '1') {
                                                            if (0 > 1) {
                                                                ieScreenBlockService.setMessage('Generating label..');
                                                                var instanceId = uuid();

                                                                printService
                                                                    .archive({
                                                                        //reportId: 'SlettvollConsignmentColli.trdp',
                                                                        reportId: 'DefaultConsignmentColli.trdp',
                                                                        parameters: {
                                                                            consignment_keyno: $stateParams.consignment_keyno,
                                                                        },
                                                                    })
                                                                    .then(function (fileItem) {
                                                                        ieScreenBlockService.setMessage('Getting file details...');

                                                                        fileService.getFileDetails({ fileName: fileItem.fileNameWithExtension, wait: true, instanceId: fileItem.instanceId }).then(function (dr) {
                                                                            ieScreenBlockService.setMessage('Printing labels....');
                                                                            vm.printCargonizerReport(dr.fileName);
                                                                        });
                                                                    })
                                                                    .catch(function (err) {
                                                                        console.log('report error:', err);
                                                                    });
                                                            } else {
                                                                ieScreenBlockService.setMessage('Printing labels....');
                                                                //vm.printConsignment();
                                                                loadPrintLabelApi();
                                                            }
                                                        });
                                                    });
                                                }
                                            });
                                        } else {
                                            vm.model.locked = '0';
                                            ieScreenBlockService.stop();

                                            modalService.show({
                                                type: 'warning',
                                                title: 'Warning',
                                                message: data[0].status_message,
                                                buttons: [
                                                    {
                                                        label: 'OK',
                                                        cssClass: 'btn-warning',
                                                        action: function (dialogItself) {
                                                            dialogItself.close();
                                                        },
                                                    },
                                                ],
                                            });
                                        }
                                    });
                                }
                            } else {
                                vm.model.locked = '0';
                                ieScreenBlockService.stop();

                                modalService.show({
                                    type: 'danger',
                                    title: 'danger',
                                    message: data[0].status_message,
                                    buttons: [
                                        {
                                            label: 'OK',
                                            cssClass: 'btn-warning',
                                            action: function (dialogItself) {
                                                dialogItself.close();
                                            },
                                        },
                                    ],
                                });
                            }
                        });
                    });
                };

                vm.confirmConsignment = function () {
                    vm.model.locked = '1';
                    ieScreenBlockService.start('message');
                    ieScreenBlockService.setMessage('Prevalidering..');

                    consignmentService.consignmentWebshopPreValidate({ consignment_keyno: $stateParams.consignment_keyno }).then(function (data) {
                        if (data[0].status_no == '0') {
                            consignmentService.deliverConsignment(vm.model.edit).then(function () {
                                vm.model.deliverConsignment = consignmentService.p2DeliverConsignment;

                                if (vm.model.deliverConsignment.validationcode === '0') {
                                    ieScreenBlockService.setMessage('Updating external party');

                                    consignmentService.completeConsignmentInWebshop({ consignment_keyno: $stateParams.consignment_keyno }).then(function () {
                                        vm.model.locked = '0';
                                        ieScreenBlockService.stop();
                                        stateService.back();
                                    });
                                } else if (vm.model.deliverConsignment.validationcode !== '0') {
                                    vm.model.locked = '0';
                                    ieScreenBlockService.stop();

                                    modalService.show({
                                        type: 'warning',
                                        title: 'Warning',
                                        message: vm.model.deliverConsignment.validationmessage,
                                        buttons: [
                                            {
                                                cssClass: 'btn-warning',
                                                label: 'OK',
                                                action: function (dialogItself) {
                                                    dialogItself.close();
                                                },
                                            },
                                        ],
                                    });
                                }
                            });
                        } else {
                            vm.model.locked = '0';
                            ieScreenBlockService.stop();

                            modalService.show({
                                type: 'warning',
                                title: 'Warning',
                                message: data[0].status_message,
                                buttons: [
                                    {
                                        label: 'OK',
                                        cssClass: 'btn-warning',
                                        action: function (dialogItself) {
                                            dialogItself.close();
                                        },
                                    },
                                ],
                            });
                        }
                    });

                    //var l_s_label_ok = 'OK';
                    //var l_s_label_cancel = 'Cancel';

                    //modalService.show({
                    //    type: 'danger',
                    //    title: 'Confirmation',
                    //    message: 'Vil du virkelig slette personen?',
                    //    buttons: [{
                    //        label: l_s_label_ok,
                    //        cssClass: 'btn-warning',
                    //        action: function (dialogItself) {
                    //            dialogItself.close();

                    //            personService.deletePerson().then(function () {
                    //                stateService.back();
                    //            });
                    //        }
                    //    }, {
                    //        label: l_s_label_cancel,
                    //        close: true
                    //    }]
                    //});
                };

                // ######################
                // DELETE BUTTON FUNCTION
                // ######################

                vm.deleteConsignment = function () {
                    vm.model.tmp_deliverymethod_no = vm.model.edit.deliverymethod_no;

                    cargonizerApiService.deleteCargonizerConsignment($stateParams.consignment_keyno).then(function () {
                        consignmentService.getEdit({ consignment_keyno: $stateParams.consignment_keyno }).then((info) => {
                            angular.copy(info[0], vm.model.edit);
                            vm.model.isDirty = true;
                            loadDeliveryMethods();
                        });
                    });
                };

                vm.deleteP2Consignment = async function () {
                    const { errorcode, errormessage } = (await consignmentService.genericFunction(3768, { consignment_keyno: $stateParams.consignment_keyno }))[0];

                    if (errorcode !== '0') {
                        modalService.confirm({ message: errormessage }).then(() => {
                            consignmentService
                                .genericFunction(758, {
                                    consignment_keyno: $stateParams.consignment_keyno,
                                })
                                .then(function (data) {
                                    stateService.back();
                                });
                        });
                    } else {
                        consignmentService
                            .genericFunction(758, {
                                consignment_keyno: $stateParams.consignment_keyno,
                            })
                            .then(function (data) {
                                stateService.back();
                            });
                    }
                };

                vm.rollbackValues = function () {
                    vm.model.lockedRollback = true;

                    consignmentService.rollbackItem({ consignment_keyno: vm.model.edit.consignment_keyno }).then(function (data) {
                        if (data[0].errorcode !== '0') {
                            modalService.show({
                                type: 'warning',
                                title: 'Varsel',
                                message: data[0].errormessage,
                                buttons: [
                                    {
                                        label: 'OK',
                                        cssClass: 'btn-warning',
                                        action: function (dialogItself) {
                                            dialogItself.close();
                                            vm.model.lockedRollback = false;
                                        },
                                    },
                                ],
                            });
                        } else {
                            vm.model.lockedRollback = false;
                            loadEdit();
                        }
                    });
                };

                // ###################################
                // GET DELIVERY METHOD BUTTON FUNCTION
                // ###################################

                async function loadDeliveryMethods() {
                    vm.model.tmp_deliverymethod_no = vm.model.edit.deliverymethod_no;
                    vm.model.selectListDeliveryMethods = [];
                    selectListDeliveryMethodsIndexed = {};

                    vm.model.selectListDeliveryMethods = await consignmentPlanningService.listDeliveryMethods({ consignment_keyno: $stateParams.consignment_keyno });

                    vm.model.selectListDeliveryMethods.forEach((item) => {
                        selectListDeliveryMethodsIndexed[item.deliverymethod_no] = {
                            deliverymethod_no: item.deliverymethod_no,
                            deliverymethod_name: item.deliverymethod_name,
                            deliverymethod_cargonizer: item.deliverymethod_cargonizer,
                        };
                    });

                    vm.checkDeliveryMethod();

                    cargonizerApiService.getCargonizerPrintersLocal($stateParams.consignment_keyno).then(function () {
                        vm.model.cargonizerPrinters = cargonizerApiService.cargonizerPrinters;
                    });
                }

                // ####################
                // SAVE BUTTON FUNCTION
                // ####################

                vm.saveConsignmentHead = function () {
                    //console.log('stocklocation_keyno: ' + vm.model.edit.stocklocation_keyno);
                    consignmentService.saveConsignmentHead(vm.model.edit).then(function () {
                        vm.model.p2ConsignmentSave = consignmentService.p2ConsignmentSave;

                        if (vm.model.p2ConsignmentSave.saveok === '1') {
                            //vm.formConsignment.$dirty = false;
                        }

                        $timeout(function () {
                            vm.model.isDirty = false;
                        }, 300);
                    });
                };

                // ###################################
                // ## FINISHED PREPICK BUTTON FUNCTION
                // ###################################

                vm.prePickFinished = function () {
                    vm.model.lockedPrePickFinished = true;

                    consignmentService.unloadStockTransferAll(vm.model.edit.stocktransfer_keyno).then(function (data) {
                        if (data[0].errorcode !== '0') {
                            modalService.show({
                                type: 'warning',
                                title: 'Feilmelding',
                                message: data[0].errormessage,
                                buttons: [
                                    {
                                        label: 'OK',
                                        cssClass: 'btn-warning',
                                        action: function (dialogItself) {
                                            dialogItself.close();
                                            vm.model.lockedPrePickFinished = false;
                                        },
                                    },
                                ],
                            });
                        } else {
                            consignmentService.getP2ConsignmentAssignSb(vm.model.edit.consignment_keyno).then(function () {
                                vm.model.p2ConsignmentAssignSb = consignmentService.p2ConsignmentAssignSb;

                                if (vm.model.p2ConsignmentAssignSb.errorcode !== '0') {
                                    modalService.show({
                                        type: 'warning',
                                        title: 'Feilmelding',
                                        message: vm.model.p2ConsignmentAssignSb.errormessage,
                                        buttons: [
                                            {
                                                label: 'OK',
                                                cssClass: 'btn-warning',
                                                action: function (dialogItself) {
                                                    dialogItself.close();
                                                    vm.model.lockedPrePickFinished = false;
                                                    loadEdit();
                                                },
                                            },
                                        ],
                                    });
                                } else {
                                    vm.model.lockedPrePickFinished = false;
                                    loadEdit();
                                }
                            });
                        }
                    });
                };

                // ###########################
                // $WATCH & $TIMEOUT FUNCTIONS
                // ###########################

                $timeout(function () {
                    if (vm.formConsignment !== undefined) {
                        vm.checkDeliveryMethod();
                    }
                });

                vm.onP2ConsigmentGetChange = function () {
                    vm.model.isDirty = true;
                };

                vm.onP2ConsigmentGetChangeStockLocation = function () {
                    vm.model.isDirty = true;

                    $timeout(function () {
                        vm.saveConsignmentHead();
                    }, 50);
                };

                // #region MULTI DIRECTION BUTTON FUNCTIONS

                vm.goToFunc = function (state, e) {
                    function go(parms) {
                        if (e?.ctrlKey) {
                            stateService.newTab(state, parms);
                        } else {
                            stateService.go(state, parms);
                        }
                    }

                    switch (state) {
                        case 'consignmentlineselect':
                            go({ consignment_keyno: vm.model.edit.consignment_keyno });
                            break;
                        default:
                            break;
                    }
                };

                // #endregion MULTI DIRECTION BUTTON FUNCTIONS

                let recalcVolumeM3 = function () {
                    if (vm.model.edit.setting_use_colli_dimensions !== '1') {
                        vm.model.edit.volum = (utilityService.parseNumber(vm.model.edit.height_cm) * utilityService.parseNumber(vm.model.edit.length_cm) * utilityService.parseNumber(vm.model.edit.width_cm)) / 1000000;
                    }
                };

                vm.checkAll = function () {
                    angular.forEach(vm.model.itemsListCollis, function (record) {
                        record.item_is_selected = '1';
                    });
                };

                vm.uncheckAll = function () {
                    angular.forEach(vm.model.itemsListCollis, function (record) {
                        record.item_is_selected = '0';
                    });
                };

                // #region FIELD CHANGE MULTI FUNCTIONS

                vm.onChanged = function (value, id) {
                    switch (id) {
                        case 'consignee_name':
                        case 'consignee_address1':
                        case 'consignee_address2':
                        case 'consignee_postcode':
                        case 'consignee_city':
                        case 'consignee_email':
                        case 'consignee_mobile':
                        case 'consignee_phone':
                        case 'consignee_contact_person':
                        case 'message_consignee':
                        case 'message_carrier':
                        case 'reference_consignee':
                        case 'consignmentshipment_keyno':
                            if (utilityService.validateWatchValue(value, vm.model.edit[id]) !== true) return;

                            vm.model.edit[id] = value;

                            if (utilityService.validateParmsValue(vm.model.edit[id], true) !== true) return;

                            vm.model.isDirty = true;
                            break;
                        case 'width_cm':
                        case 'height_cm':
                        case 'length_cm':
                            if (utilityService.validateWatchValue(value, vm.model.edit[id]) !== true) return;

                            vm.model.edit[id] = value;

                            if (utilityService.validateParmsValue(vm.model.edit[id], true) !== true) return;

                            vm.model.isDirty = true;
                            recalcVolumeM3();
                            break;
                        case 'deliverymethod_no':
                        case 'weight':
                        case 'volum':
                            if (utilityService.validateWatchValue(value, vm.model.edit[id]) !== true) return;

                            vm.model.edit[id] = value;

                            if (utilityService.validateParmsValue(vm.model.edit[id]) !== true) return;

                            vm.model.isDirty = true;

                            vm.checkDeliveryMethod();
                            break;
                        case 'stocklocation_keyno':
                            if (timerStockLocationKeyno) clearTimeout(timerStockLocationKeyno);

                            if (utilityService.validateWatchValue(value, vm.model.edit.stocklocation_keyno) !== true) return;

                            vm.model.edit.stocklocation_keyno = value;

                            if (utilityService.validateParmsValue(vm.model.edit.stocklocation_keyno) !== true) return;

                            vm.model.isDirty = true;

                            timerStockLocationKeyno = setTimeout(() => {
                                vm.saveConsignmentHead();
                            }, 50);
                            break;
                        default:
                            utilityService.setValueToVariable(value);
                            break;
                    }
                };

                // #endregion FIELD CHANGE MULTI FUNCTIONS

                // #region CARGONIZER FUNCTIONS

                vm.prodIDSearch = function (value) {
                    value ??= '';

                    return consignmentService.getProdKeyname(value);
                };

                vm.selectProdID = function (item, model) {
                    vm.model.edit.prod_id_freight = '';

                    if (item?.prod_id && item.prod_id !== '') {
                        vm.model.edit.prod_id_freight = item.prod_id;

                        consignmentService.getOrderlineProdSum(vm.model.edit.consignment_keyno, item.prod_id).then(function (result) {
                            if (result?.[0]?.sum_amount_net_locval) {
                                vm.model.edit.order_freight = result[0].sum_amount_net_locval;
                            }
                        });
                    }
                };

                vm.checkFreight = function () {
                    if (utilityService.parseNumber(vm.model.edit.order_freight) === 0) {
                        return false;
                    } else return true;
                };

                vm.getEstimatedFreight = function () {
                    consignmentService.getEstimatedFreight(vm.model.edit.consignment_keyno, vm.model.edit.deliverymethod_no, vm.model.edit.colli, vm.model.edit.weight, vm.model.edit.volum).then(function (result) {
                        if (result[0].errorcode === '0') {
                            vm.model.edit.est_freight = result[0].estimated_cost;
                        } else {
                            modalService.show({
                                type: 'danger',
                                title: 'ERROR',
                                message: result[0].errormessage,
                                buttons: [
                                    {
                                        label: 'OK',
                                        cssClass: 'btn-danger',
                                        action: function (modalInstanceError) {
                                            modalInstanceError.close();
                                        },
                                    },
                                ],
                            });
                        }
                    });
                };

                vm.handleEstimatedFreight = function () {
                    consignmentService.handleEstimatedFreight(vm.model.edit.consignment_keyno, vm.model.edit.prod_id_freight, vm.model.edit.est_freight).then(function (result) {
                        if (!result.iserror) loadEdit(true);
                    });
                };

                // #endregion CARGONIZER FUNCTIONS

                // #region SHOW PROGRESSBAR DIALOGUE BOX FUNCTION

                function activateDeleteProgress(items) {
                    let increment = 1,
                        skip = 0,
                        failed = 0,
                        step = 0;
                    progress.step = 0;

                    function doStep() {
                        setTimeout(() => {
                            modalService.progressInfo.finishclose = '0';

                            if (progress.runProgress === 'ABORT') return;
                            if (progress.step >= progress.max) return;

                            step = progress.step + skip + failed;
                            progress.field = 'ID: ' + items[step].consignmentline_keyno;
                            modalService.progressInfo.field = progress.field;

                            consignmentService.deleteAssign({ consignmentline_keyno: items[step].consignmentline_keyno }).then((response) => {
                                if (response[0].errorcode !== '0') {
                                    modalService.show({
                                        type: 'warning',
                                        title: translations.error,
                                        message: response[0].errormessage,
                                        buttons: [
                                            {
                                                label: translations.ok,
                                                cssClass: 'btn-warning',
                                                action: (dialogItself) => {
                                                    dialogItself.close();

                                                    progress.runProgress = 'ABORT';
                                                    modalService.progressInfo.finishclose = '1';
                                                    modalService.progressInfo.abortclose = true;

                                                    doStep();
                                                },
                                            },
                                        ],
                                    });
                                } else {
                                    progress.step += increment;
                                    modalService.progressInfo.step = progress.step;
                                    modalService.progressInfo.finishclose = progress.finishclose;

                                    doStep();
                                }
                            });
                        });
                    }

                    doStep();
                }

                function progressDeleteFunc() {
                    let allRows = vm.gridConsignmentLine.gridfunc.getAllRows();
                    let selectedRows = [];

                    allRows.forEach((item) => {
                        if (item.is_selected === '1' || item.is_selected === true) selectedRows.push(item);
                    });

                    if (selectedRows.length === 0) return;

                    progress.max = selectedRows.length;
                    activateDeleteProgress(selectedRows);

                    modalService.showProgress(progress).then(function (value) {
                        progress.runProgress = value;

                        if (progress.runProgress === 'ABORT') return;
                        if (progress.runProgress === 'FINISH') loadGridConsignmentLine();
                    });
                }

                // #endregion SHOW PROGRESSBAR DIALOGUE BOX FUNCTION

                // #region BUTTON RADIO FUNCTIONS

                vm.selectBgConsignmentSelection = function (value) {
                    vm.model.bgConsignmentSelection.selected = value;
                    vm.model.edit.bg_consignmentselection = vm.model.bgConsignmentSelection.selected;

                    rememberFunc('bg_consignmentselection');

                    if (vm.model.bgConsignmentSelection.selected === 'packing') loadCollis();
                };

                vm.selectBgConsignmentOther = function (value) {
                    vm.model.bgConsignmentOther.selected = value;
                };

                vm.selectBgConsignmentAddressSelection = function (value) {
                    vm.model.bgConsignmentAddressSelection.selected = value;
                };

                vm.selectBgConsignmentAddressInfoSelection = function (value) {
                    vm.model.bgConsignmentAddressInfoSelection.selected = value;
                };

                vm.selectBgConsignmentPackingSelection = function (value) {
                    vm.model.bgConsignmentPackingSelection.selected = value;
                    vm.model.edit.bg_consignment_packing_selection = vm.model.bgConsignmentPackingSelection.selected;

                    rememberFunc('bg_consignment_packing_selection');
                    loadCollis();
                };

                vm.selectBgConsignmentPickSelection = function (value) {
                    vm.model.bgConsignmentPickSelection.selected = value;
                    vm.model.edit.bg_ConsignmentPickSelection = vm.model.bgConsignmentPickSelection.selected;
                };

                vm.selectBgAuto = function (value) {
                    vm.model.bgAuto.selected = value;
                };

                // #endregion BUTTON RADIO FUNCTIONS

                // #region ON INIT FUNCTION

                vm.$onInit = function () {
                    translate();
                    loadEdit();
                    loadGridConsignmentLine();
                };

                // #endregion ON INIT FUNCTION
            },
        ],
    });
})();
